<template>
  <toggle-details>
    <div
      slot-scope="{ opened, toggle }"
      class="add-ons-taxes-overview"
    >
      <button
        class="add-on-activator"
        :class="{'--opened': opened}"
        aria-label="Toggle details"
        :aria-expanded="opened ? 'true' : 'false'"
        @click="toggle"
        @enter="toggle"
        @space.prevent="toggle"
      >
        <div class="add-ons-taxes-overview-title">
          {{ totalLabel }}
        </div>
        <div class="add-ons-taxes-overview-total">
          {{ getFormattedPrice(addOnsTotalTaxes) }}
        </div>
      </button>
      <transition name="expand-y">
        <ul
          v-if="opened"
          class="addons-list"
        >
          <li
            v-for="(addOn, index) in addOns"
            :key="`addon-${index}`"
            class="addon-item"
          >
            <div class="addon-item-header">
              <div class="addon-title">
                {{ addOn.addOnName }}
              </div>
            </div>
            <ul class="addon-taxes">
              <li class="addon-tax">
                <div
                  v-for="(tax, taxIndex) in addOn.taxes.taxLine"
                  :key="`tax-${taxIndex}`"
                  class="addon-tax-line"
                >
                  <div class="addon-tax-name">
                    {{ tax.taxLineDescription }}
                  </div>
                  <div class="addon-tax-amount">
                    {{ getTaxTotalPrice(addOn, tax) }}
                  </div>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </transition>
      <ul
        class="addons-list print-only"
      >
        <li
          v-for="(addOn, index) in addOns"
          :key="`addon-${index}`"
          class="addon-item"
        >
          <div class="addon-item-header">
            <div class="addon-title">
              {{ addOn.addOnName }}
            </div>
          </div>
          <ul class="addon-taxes">
            <li
              v-for="(tax, taxIndex) in addOn.taxes.taxLine"
              :key="`tax-${taxIndex}`"
              class="addon-tax"
            >
              <div class="addon-tax-name">
                {{ tax.taxLineDescription }}
              </div>
              <div class="addon-tax-amount">
                {{ getFormattedPrice(tax.taxLinePrice) }}
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </toggle-details>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'AddOnTaxesOverview',
    inject: ['modifyAddOnsData'],
    props: {
      addOns: {
        type: Array,
        required: true
      },
      currencyCode: {
        type: String,
        required: true
      }
    },
    computed: {
      ...mapGetters('i18n', ['tc']),
      ...mapGetters('currency', ['getDisplayPrice', 'orSelected']),

      addOnsTotalTaxes() {
        if (!Array.isArray(this.addOns)) {
          return 0
        }

        return this.addOns?.reduce(
          (total, addOn) => {
            const countNights = addOn.timeSpan.length || 1
            const taxPrice = (addOn.excludeKidsFromPriceCalculations
              ? addOn.taxes.totalNoChildTaxPricePaidForAddOnByUser
              : addOn.taxes.totalTaxPricePaidForAddOnByUser) * countNights
            return total + taxPrice
          },
          0
        )
      },
      totalLabel() {
        return this.modifyAddOnsData?.addonsTaxesTotalLabel || ''
      },
    },
    methods: {
      getFormattedPrice(price) {
        return this.getDisplayPrice({
          price,
          fromCurrency: this.currencyCode,
          toCurrency:
            this.orSelected(this.currencyCode),
          withIsoCode: true,
          isoAfter: true,
        })
      },
      getTaxTotalPrice(addOn, tax) {
        const quantity = addOn.excludeKidsFromPriceCalculations ? addOn.adultQuantity : addOn.quantity
        const countNights = addOn.timeSpan.length || 1
        return this.getFormattedPrice(tax.taxLinePrice * quantity * countNights)
      }
    }
  }
</script>
